import { createTheme } from '@mui/material/styles';

const ThemeFaroIT = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        InputLabelProps: {
          shrink: true,
        },
      },
    },
  },
});

export default ThemeFaroIT;
